import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-background py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-122" data-mp="1iwcxjc03p0fu">
      <div className="mx-auto max-w-6xl px-4" data-id="element-123" data-mp="1dxji3e196zd1">
        <SectionHeading id="modules-title" data-id="element-124" data-mp="1dunhtj1xnylf">The {totalVolumes} <span className="text-highlight" data-id="element-125" data-mp="2bj7ew01mfjp3">Professional Volumes</span></SectionHeading>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-126" data-mp="26kw33jrrmz48">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-2xl border border-primary/70 bg-surface p-6 shadow-lg shadow-black/30" data-id="element-127" data-mp="21nvzrgmawagt" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-128" data-mp="1ns8vk4kg2pth">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-highlight/40 bg-background text-highlight" data-id="element-129" data-mp="18w16apu6iy7c">
                    <Icon className="glow-led h-5 w-5" aria-hidden="true" data-id="element-130" data-mp="104r306tcvnpg" />
                  </span>
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-accent" data-id="element-131" data-mp="14vh77gq1pkik">Volume {module.number}</p>
                </div>
                <h3 className="mt-4 text-xl font-extrabold uppercase leading-tight text-foreground" data-id="element-132" data-mp="q7mc5tokf42b">{module.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-133" data-mp="v65yvwazgjvq">{module.summary}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}